// 前台路由页面配置
import main from "../../views/Frontpage/main/index.vue"; // 前台页面
export const FrontpageRouter = [
  {
    path: "/",
    name: "wenxiang",
    component: main,
    redirect: "/wenxiang/home",
    children: [
      {
        path: "/wenxiang/extendAuthorization",
        name: "extendAuthorization",
        component: () =>
          import("../../views/Frontpage/extendAuthorization/index.vue"),
        children: [],
      },
      {
        // 首页
        path: "/wenxiang/home",
        name: "home",
        component: () => import("../../views/Frontpage/Home/index.vue"),
        meta: {
          transparency_Head: true,
          affiliation_Head: "home", // 归属级 (头部的)
          affiliation_Left: "home", // 归属级 (左侧的)
          skip_login: true, // 免登录 设置为true
        },
      },
      {
        // 数据首页
        path: "/wenxiang/homedata",
        name: "homedata",
        component: () => import("../../views/Frontpage/Home/index.vue"),
        meta: {
          transparency_Head: true,
          affiliation_Head: "homedata", // 归属级 (头部的)
          affiliation_Left: "homedata", // 归属级 (左侧的)
        },
      },
      {
        // 专递课堂
        path: "/wenxiang/DeliveryClassroom",
        name: "DeliveryClassroom",
        component: () =>
          import("../../views/Frontpage/DeliveryClassroom/index.vue"),
        meta: {
          transparency_Head: true,
          affiliation_Head: "DeliveryClassroom", // 归属级 (头部的)
          affiliation_Left: "DeliveryClassroom", // 归属级 (左侧的)
          skip_login: true, // 免登录 设置为true
        },
      },
      {
        // 新闻公告
        path: "/wenxiang/newsBulletin",
        name: "newsBulletin",
        component: () => import("../../views/Frontpage/newsBulletin/index.vue"),
        meta: {
          // transparency_Head: true,
          affiliation_Head: "newsBulletin", // 归属级 (头部的)
          affiliation_Left: "newsBulletin", // 归属级 (左侧的)
          skip_login: true, // 免登录 设置为true
        },
      },
      {
        // 新闻公告详情
        path: "/wenxiang/newsBulletin_info",
        name: "newsBulletin_info",
        component: () =>
          import("../../views/Frontpage/newsBulletin/newsBulletin_info.vue"),
        meta: {
          // transparency_Head: true,
          affiliation_Head: "newsBulletin", // 归属级 (头部的)
          affiliation_Left: "newsBulletin", // 归属级 (左侧的)
          skip_login: true, // 免登录 设置为true
        },
      },
      {
        // 远程互动 - 详情 （直播/课程）
        path: "/wenxiang/DeliveryClassroom_VeiwDetail",
        name: "DeliveryClassroom_VeiwDetail",
        component: () =>
          import("../../views/Frontpage/DeliveryClassroom/videoView/index.vue"),
        meta: {
          transparency_Head: false,
          affiliation_Head: "DeliveryClassroom", // 归属级 (头部的)
          affiliation_Left: "DeliveryClassroom_VeiwDetail", // 归属级 (左侧的)
          skip_login: true, // 免登录 设置为true
        },
      },
      {
        // 结对组/远程互动(更多列表页)
        path: "/wenxiang/MoreActivity",
        name: "MoreActivity",
        component: () =>
          import(
            "../../views/Frontpage/DeliveryClassroom/moreActivity/index.vue"
          ),
        meta: {
          skip_login: true, // 免登录 设置为true
          transparency_Head: true,
          affiliation_Head: "DeliveryClassroom", // 归属级 (头部的)
          affiliation_Left: "MoreActivity", // 归属级 (左侧的)
        },
      },
      {
        // 结对组详情
        path: "/wenxiang/activityDetails",
        name: "activityDetails",
        component: () =>
          import(
            "../../views/Frontpage/DeliveryClassroom/activityDetails/index.vue"
          ),
        meta: {
          transparency_Head: true,
          affiliation_Head: "DeliveryClassroom", // 归属级 (头部的)
          affiliation_Left: "activityDetails", // 归属级 (左侧的)
        },
      },
      // // 个人信息
      // {
      //   path: "/wenxiang/userInfo",
      //   menuId: "userInfo",
      //   name: "userInfo",
      //   component: () => import("@/views/Frontpage/userInfo"),
      //   meta: {
      //     affiliation_Head: "userInfo", // 归属级 (头部的)
      //     affiliation_Left: "userInfo", // 归属级 (左侧的)
      //   },
      // },
      // 教师空间
      {
        path: "/wenxiang/TeacherSpace",
        menuId: "TeacherSpace",
        name: "TeacherSpace",
        component: () => import("../../views/Frontpage/TeacherSpace/index.vue"),
        meta: {
          affiliation_Head: "TeacherSpace", // 归属级 (头部的)
          affiliation_Left: "TeacherSpace", // 归属级 (左侧的)
        },
      },
      // 学生空间
      {
        path: "/wenxiang/TeacherSpaceStudent",
        menuId: "TeacherSpaceStudent",
        name: "TeacherSpaceStudent",
        component: () =>
          import("../../views/Frontpage/TeacherSpace/student.vue"),
        meta: {
          affiliation_Head: "TeacherSpace", // 归属级 (头部的)
          affiliation_Left: "TeacherSpace", // 归属级 (左侧的)
        },
      },
      // 班级空间
      {
        path: "/wenxiang/TeacherSpaceClassroom",
        menuId: "TeacherSpaceClassroom",
        name: "TeacherSpaceClassroom",
        component: () =>
          import("../../views/Frontpage/TeacherSpace/classroom.vue"),
        meta: {
          affiliation_Head: "TeacherSpace", // 归属级 (头部的)
          affiliation_Left: "TeacherSpace", // 归属级 (左侧的)
        },
      },
      // 学生-个人信息
      {
        path: "/wenxiang/TeacherSpaceXuesheng",
        menuId: "TeacherSpaceXuesheng",
        name: "TeacherSpaceXuesheng",
        component: () =>
          import("../../views/Frontpage/TeacherSpace/xuesheng.vue"),
        meta: {
          affiliation_Head: "TeacherSpace", // 归属级 (头部的)
          affiliation_Left: "TeacherSpace", // 归属级 (左侧的)
        },
      },
      // 游客-个人信息
      {
        path: "/wenxiang/TeacherSpaceYouke",
        menuId: "TeacherSpaceYouke",
        name: "TeacherSpaceYouke",
        component: () => import("../../views/Frontpage/TeacherSpace/youke.vue"),
        meta: {
          affiliation_Head: "TeacherSpace", // 归属级 (头部的)
          affiliation_Left: "TeacherSpace", // 归属级 (左侧的)
        },
      },
      // 我的课表
      {
        path: "/wenxiang/MySchoolTimetable",
        menuId: "MySchoolTimetable",
        name: "MySchoolTimetable",
        component: () =>
          import("../../views/Frontpage/MySchoolTimetable/index.vue"),
        meta: {
          affiliation_Head: "MySchoolTimetable", // 归属级 (头部的)
          affiliation_Left: "MySchoolTimetable", // 归属级 (左侧的)
        },
      },
      {
        // 教研活动
        path: "/wenxiang/TeachingActivities",
        name: "TeachingActivities",
        component: () =>
          import("../../views/Frontpage/TeachingActivities/index.vue"),
        redirect: "/wenxiang/TeachingActivitiesList",
        meta: {
          transparency_Head: true,
          affiliation_Head: "TeachingActivities", // 归属级 (头部的)
          affiliation_Left: "TeachingActivities", // 归属级 (左侧的)
        },
        children: [
          {
            // 列表
            path: "/wenxiang/TeachingActivitiesList",
            name: "TeachingActivitiesList",
            component: () =>
              import("../../views/Frontpage/TeachingActivities/Activities.vue"),
            meta: {
              transparency_Head: true,
              affiliation_Head: "TeachingActivities", // 归属级 (头部的)
              affiliation_Left: "TeachingActivities", // 归属级 (左侧的)
              skip_login: true, // 免登录 设置为true
            },
          },
          {
            // 更多
            path: "/wenxiang/TeachingActivitiesMore",
            name: "TeachingActivitiesMore",
            component: () =>
              import("../../views/Frontpage/TeachingActivities/more.vue"),
            meta: {
              transparency_Head: true,
              affiliation_Head: "TeachingActivities", // 归属级 (头部的)
              affiliation_Left: "TeachingActivities", // 归属级 (左侧的)
              skip_login: true, // 免登录 设置为true
            },
          },
        ],
      },
      {
        // 教研活动 - 详情 （直播/课程）
        path: "/wenxiang/TeachingActivities_VeiwDetail",
        name: "TeachingActivities_VeiwDetail",
        component: () =>
          import("../../views/Frontpage/TeachingActivities/videoView"),
        meta: {
          transparency_Head: false,
          affiliation_Head: "TeachingActivities", // 归属级 (头部的)
          affiliation_Left: "TeachingActivities", // 归属级 (左侧的)
          skip_login: true, // 免登录 设置为true
        },
      },
      {
        // 系列课
        path: "/wenxiang/SeriesCourse",
        name: "SeriesCourse",
        component: () => import("../../views/Frontpage/SeriesCourse/index.vue"),
        meta: {
          transparency_Head: true,
          affiliation_Head: "SeriesCourse", // 归属级 (头部的)
          affiliation_Left: "SeriesCourse", // 归属级 (左侧的)
          skip_login: true, // 免登录 设置为true
        },
      },
      {
        // 系列课
        path: "/wenxiang/SeriesCourseLi",
        name: "SeriesCourseLi",
        component: () =>
          import("../../views/Frontpage/SeriesCourse/SeriesCourseLi.vue"),
        meta: {
          transparency_Head: true,
          affiliation_Head: "SeriesCourse", // 归属级 (头部的)
          affiliation_Left: "SeriesCourseLi", // 归属级 (左侧的)
          skip_login: true, // 免登录 设置为true
        },
      },
      {
        // 系列课详情
        path: "/wenxiang/SeriesCourseLiInfo",
        name: "SeriesCourseLiInfo",
        component: () =>
          import("../../views/Frontpage/SeriesCourse/SeriesCourseLiInfo.vue"),
        meta: {
          skip_login: true,
          affiliation_Head: "SeriesCourse", // 归属级 (头部的)
          affiliation_Left: "SeriesCourseLiInfo", // 归属级 (左侧的)
        },
      },
      {
        // 精品课程
        path: "/wenxiang/ExcellentCourse",
        name: "ExcellentCourse",
        component: () =>
          import("../../views/Frontpage/ExcellentCourse/index.vue"),
        meta: {
          transparency_Head: true,
          affiliation_Head: "ExcellentCourse", // 归属级 (头部的)
          affiliation_Left: "ExcellentCourse", // 归属级 (左侧的)
          skip_login: true, // 免登录 设置为true
        },
      },
      {
        // 精品课程详情
        path: "/wenxiang/ExcellentCourseLi",
        name: "ExcellentCourseLi",
        component: () =>
          import("../../views/Frontpage/ExcellentCourseLi/index.vue"),
        meta: {
          skip_login: true,
          affiliation_Head: "ExcellentCourse", // 归属级 (头部的)
          affiliation_Left: "ExcellentCourseLi", // 归属级 (左侧的)
        },
      },
      {
        // 在线课堂
        path: "/wenxiang/LiveStreamingActivities",
        name: "LiveStreamingActivities",
        component: () =>
          import("../../views/Frontpage/LiveStreamingActivities/index.vue"),
        meta: {
          transparency_Head: true,
          skip_login: true, // 免登录 设置为true
          affiliation_Head: "LiveStreamingActivities", // 归属级 (头部的)
          affiliation_Left: "LiveStreamingActivities", // 归属级 (左侧的)
        },
      },
      {
        // 课例评课报告
        path: "/wenxiang/LessonEvaluationReport",
        name: "LessonEvaluationReport",
        component: () =>
          import("../../views/Frontpage/LessonEvaluationReport/index.vue"),
        meta: {
          mark: "homedata",
          transparency_Head: true,
          skip_login: true, // 免登录 设置为true
          affiliation_Head: "LessonEvaluationReport", // 归属级 (头部的)
          affiliation_Left: "LessonEvaluationReport", // 归属级 (左侧的)
        },
      },
      // 直播详情列表
      {
        path: "/wenxiang/liveDetailsList",
        name: "liveDetailsList",
        component: () =>
          import(
            "../../views/Frontpage/LiveStreamingActivities/liveDetailsList/index.vue"
          ),
        meta: {
          affiliation_Head: "LiveStreamingActivities", // 归属级 (头部的)
          affiliation_Left: "liveDetailsList", // 归属级 (左侧的)
          skip_login: true, // 免登录 设置为true
        },
      },
      {
        // 前台课表
        path: "/wenxiang/Curriculum",
        name: "Curriculum",
        component: () => import("../../views/Frontpage/Curriculum/index.vue"),
        meta: {
          transparency_Head: true,
          skip_login: true, // 免登录 设置为true
          affiliation_Head: "Curriculum", // 归属级 (头部的)
          affiliation_Left: "Curriculum", // 归属级 (左侧的)
        },
      },
      // AI行为分析
      {
        path: "/wenxiang/courseDetails",
        menuId: "courseDetails",
        name: "courseDetails",
        component: () =>
          import("../../views/Frontpage/courseDetails/index.vue"),
        meta: {
          skip_login: true, // 免登录 设置为true
          affiliation_Head: "LiveStreamingActivities", // 归属级 (头部的)
          affiliation_Left: "courseDetails", // 归属级 (左侧的)
        },
      },
      {
        // 数据分析报告
        path: "/wenxiang/dataAnalysisReport",
        name: "dataAnalysisReport",
        component: () =>
          import("../../views/Frontpage/dataAnalysisReport/index.vue"),
        meta: {
          mark: "homedata",
          transparency_Head: true,
          skip_login: true, // 免登录 设置为true
          affiliation_Head: "dataAnalysisReport", // 归属级 (头部的)
          affiliation_Left: "dataAnalysisReport", // 归属级 (左侧的)
        },
      },
      {
        // 课程报告
        path: "/wenxiang/exportReport",
        name: "exportReport",
        component: () =>
          import("../../views/Frontpage/dataAnalysisReport/exportReport.vue"),
        meta: {
          mark: "homedata",
          transparency_Head: true,
          skip_login: true, // 免登录 设置为true
          affiliation_Head: "dataAnalysisReport", // 归属级 (头部的)
          affiliation_Left: "dataAnalysisReport", // 归属级 (左侧的)
        },
      },
      {
        // 课程资源列表
        path: "/wenxiang/course-resource/list",
        name: "courseResourceList",
        component: () =>
          import("../../views/Frontpage/course-resource/list/index.vue"),
        meta: {
          skip_login: true,
          transparency_Head: true,
          affiliation_Head: "course-resource", // 归属级 (头部的)
          affiliation_Left: "course-resource", // 归属级 (左侧的)
        },
      },
      {
        // 课程详情
        path: "/wenxiang/course-resource/detail",
        name: "courseResourceDetail",
        component: () =>
          import("../../views/Frontpage/course-resource/detail/index.vue"),
        meta: {
          skip_login: true,
          transparency_Head: true,
          affiliation_Head: "course-resource", // 归属级 (头部的)
          affiliation_Left: "course-resource", // 归属级 (左侧的)
        },
      },
      {
        // 课程资源 详情 （资源播放）
        path: "/wenxiang/courseResource",
        name: "courseResource",
        component: () =>
          import("../../views/Frontpage/courseDetails/courseResource"),
        meta: {
          affiliation_Head: "course-resource", // 归属级 (头部的)
          affiliation_Left: "course-resource", // 归属级 (左侧的)
          transparency_Head: false,
          skip_login: false, // 免登录 设置为true
        }
      },
    ],
  },
  {
    // 课程资源 详情 （资源播放）
    path: "/wenxiang/courseResourceBack",
    name: "courseResourceBack",
    component: () =>
      import("../../views/Frontpage/courseDetails/courseResource"),
    meta: {
      affiliation_Head: "course-resource", // 归属级 (头部的)
      affiliation_Left: "course-resource", // 归属级 (左侧的)
      transparency_Head: false,
      skip_login: false, // 免登录 设置为true
    },
  },
];
